/**
 * Format a date as a relative string: "today", "yesterday", "tomorrow",
 * "3 days ago", "in 2 days", "last week", "next week", "last month", etc.
 * Falls back to a short absolute date for far past/future.
 */
export function formatRelativeDate(date: string | Date): string {
  const d = typeof date === "string" ? new Date(date) : date
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const other = new Date(d.getFullYear(), d.getMonth(), d.getDate())
  other.setHours(0, 0, 0, 0)

  const diffMs = other.getTime() - today.getTime()
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24))

  if (diffDays === 0) return "today"
  if (diffDays === 1) return "tomorrow"
  if (diffDays === -1) return "yesterday"
  if (diffDays >= 2 && diffDays <= 6) return `in ${diffDays} days`
  if (diffDays >= -6 && diffDays <= -2) return `${Math.abs(diffDays)} days ago`
  if (diffDays >= 7 && diffDays <= 13) return "next week"
  if (diffDays >= -13 && diffDays <= -7) return "last week"
  if (diffDays >= 14 && diffDays <= 20) return "in 2 weeks"
  if (diffDays >= -20 && diffDays <= -14) return "2 weeks ago"
  if (diffDays >= 21 && diffDays <= 60) return "next month"
  if (diffDays >= -60 && diffDays <= -21) return "last month"
  if (diffDays > 60 || diffDays < -60) {
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: d.getFullYear() !== today.getFullYear() ? "numeric" : undefined })
  }
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" })
}

/** Display title for a report: "Property name – relative date" when we have both, else stored title. */
export function getReportDisplayTitle(report: {
  title: string
  activity_date?: string
  clean_date?: string
  property?: { name?: string } | null
}): string {
  const name = report.property?.name?.trim()
  const date = report.activity_date ?? report.clean_date
  if (name && date) {
    return `${name} – ${formatRelativeDate(date)}`
  }
  return report.title?.trim() || "Untitled Report"
}
